import { z } from 'zod/v3';

// File category constants
export const FILE_CATEGORIES = [
  'avatar',
  'article',
  'source',
  'logo',
  'favicon',
  'meta',
  'other'
] as const;

// File category type
export type FileCategory = typeof FILE_CATEGORIES[number];

// File category Zod schema
export const FileCategorySchema = z.enum(FILE_CATEGORIES);
